
<template>
    <div 
    :class="{
        
    }">
        <template v-for="(item, index) in data" >
            <h-tree-item 
                :key="index" 
                :list="item"
                :props="props"
                :highlight-current="highlightCurrent"
                :show-checkbox="showCheckbox"
                :expand-on-click-node="expandOnClickNode"
                @node-click="nodeClick"
                :node-key="nodeKey"
                @check-change="checkChange"
            >
                <slot :node="item"></slot>
            </h-tree-item>
        </template>
    </div>
</template>

<script>
import HTreeItem from "./components/HTreeItem";
export default {
    name: 'h-tree',
    props: {
        // 数据源
        data: {
            type: [Object, Array],
            required: true
        },
        // 树节点参数
        props:{
            type:Object,
            default:()=>{}
        },
        // 是否高亮
        highlightCurrent:{
            type:Boolean,
            default:()=> false
        },
        // 是否多选
        showCheckbox:{
            type:Boolean,
            default:()=> false
        },
        expandOnClickNode:{
            type:Boolean,
            default:()=> true
        },
        nodeKey:{
            type:String,
            default:()=> ''
        }
    },
    data(){
        return {
            chechNode:[]
        }
    },
    components: {
        HTreeItem
    },
    methods:{
        // 节点点击事件
        nodeClick(node){
            this.$emit('node-click',node)
        },
        // 复选款节点勾选变化事件
        checkChange(node){
            console.log(node,"ppppp")
            this.chechNode = node
            this.$emit('check-change',node)
        },
        // 获取复选款node-key返回值
        getCheckedKeys(){
            let nodeKeys = this.chechNode.map(v=>{
                return v[this.nodeKey]
            })
            return nodeKeys
        },
        //获取复选款勾选中的node节点信息
        getCheckedNodes(){
            return this.chechNode
        }
    }
};
</script>
<style lang="less" scoped>
.h-tree{
    // width: 100%;
}
.current-node{
    background: #f5f7fa;
}
.highlight-current{
    background: #c6e2ff;
}
</style>


